<form [formGroup]="rejectForm" (ngSubmit)="saveform(rejectForm)">
  <div mat-dialog-content>
    <p><b>Please provide reason for revision for this kaizen?</b></p>
    <br>Reason <br>
    <textarea class="col-md-12" cols="12" formControlName="cmdcomments"></textarea><br>
    @if (!rejectForm.controls.cmdcomments.valid) {
      <div class="validation"  >Reason is mandatory</div>
    }
    <br><br>
  </div>
  <div mat-dialog-actions>
    <div class="col-12">
      <button [disabled]="!rejectForm.controls.cmdcomments.valid" mat-flat-button type="submit" color="primary" >Yes</button>
      <button  mat-flat-button type="button" color="primary" [mat-dialog-close]="false">No</button>
    </div>
  </div>
</form>